import React, { useContext } from 'react';
import { swatchCss } from 'src/components/ProductDetail/utils/swatchData';
import { BundleSelectionContext, useFormDataCausesRender } from 'src/components/BundleProduct/BundleSelectionProvider';
import classnames from 'classnames';
import { Price } from 'src/components/Helpers/Price';

import classes from './ProductBundleSummary.scss';

export const TableBody: React.FC = React.memo(() => {
    const { items } = useFormDataCausesRender();

    return (
        <tbody>
            {items.map((formItem) => {
                const swatch = formItem.swatch;
                const css = swatchCss(swatch.swatch_data);
                return (
                    <tr key={formItem.swatch.value_index}>
                        <td className={classes.colour}>
                            <span className={classes.colourSwatch}>
                                <span style={css} className={classes.swatch}>
                                    {' '}
                                </span>{' '}
                                {swatch.title}
                            </span>
                        </td>
                        <td className={classes.size}>
                            {formItem.sizes.map((size) => {
                                return (
                                    <React.Fragment key={size.size.id}>
                                        {size.size.title}
                                        <br />
                                    </React.Fragment>
                                );
                            })}
                        </td>
                        <td className={classes.qty}>
                            {formItem.sizes.map((size) => {
                                return (
                                    <b key={size.size.id}>
                                        {size.qty}
                                        <br />
                                    </b>
                                );
                            })}
                        </td>
                    </tr>
                );
            })}
        </tbody>
    );
});

export const TableFoot: React.FC<{ price: any; vat: any }> = React.memo((props) => {
    const { price, vat } = props;

    return (
        <tfoot>
            <tr>
                <td colSpan={2} className={classes.tdSummary}>
                    Total items
                </td>
                <td
                    colSpan={1}
                    className={classnames({
                        [classes.tdSummary]: true,
                        [classes.makeGreen]: true,
                    })}
                >
                    <BundleSummaryCount />
                </td>
            </tr>

            <tr>
                <td colSpan={2} className={classes.tdSummary}>
                    Bundle Price
                </td>
                <td
                    colSpan={1}
                    className={classnames({
                        [classes.tdSummary]: true,
                        [classes.makeGreen]: true,
                    })}
                >
                    <Price price={price} priceIncl={price} vat={vat} />
                </td>
            </tr>
        </tfoot>
    );
});

export const BundleSummaryCount: React.FC = () => {
    const { maxQty } = useContext(BundleSelectionContext);
    const { totalQty } = useFormDataCausesRender();
    return (
        <>
            {totalQty} / {maxQty}
        </>
    );
};
